import React, { useReducer, useContext } from 'react'
import { navigation } from '../reducers/navigationReducer'
import { useLocation } from 'react-router-dom';
import { navigationPathsMap } from '../utils/navigationConstants';

const navigationContext = React.createContext();

export const NavigationProvider = ({children}) => {
    const location = useLocation();

    const initialValue = navigationPathsMap.get(location.pathname);
    const valueContext = useReducer(navigation, initialValue);

    return (
        <navigationContext.Provider value={valueContext}>
            {children}
        </navigationContext.Provider>
    );
}

export const useNavigation = () => {
    const contextValue = useContext(navigationContext);
    return contextValue;
}